<template>
    <div>
        <Panel
            :title="$t('Summarisation Templates')"
            :add-button="$store.hasRight('EDIT_SUMMARISATION_TEMPLATES') ? $t('Add New Template') : ''"
            :delete-button="selected.length > 0"
            @delete="deleteSelectedTemplates"
            @input="openForm(null)"
        >
            <table id="summarytemplates_table" class="cic-table">
                <thead>
                    <tr>
                        <th>{{ $t('Template Name') }}</th>
                        <th v-if="$store.hasRight('EDIT_SUMMARISATION_TEMPLATES')" class="td-checkbox"></th>
                    </tr>
                </thead>
                <tbody>
                    <tr
                        v-for="template in templates"
                        :key="template.templateId"
                        @click="(evt) => handleOpen(template.templateId, evt)"
                    >
                        <td class="primary">{{ template.templateName }}</td>
                        <td v-if="$store.hasRight('EDIT_SUMMARISATION_TEMPLATES')">
                            <cic-checkbox
                                :value="selected.indexOf(template.templateId) !== -1"
                                @input="handleSelected(template.templateId)"
                            />
                        </td>
                    </tr>
                </tbody>
            </table>
        </Panel>
        <EditTemplateDefinition
            v-if="item"
            :item="item"
            :queues="queues"
            :groups="agentGroups"
            :languages="languages"
            @blur="item = null"
            @change="updateFieldValue"
            @input="handleTemplateSave"
        />
    </div>
</template>

<script>
    import Panel from '@/components/container/Panel';
    import CicCheckbox from '@/components/inputs/CicCheckbox';
    import EditTemplateDefinition from './EditTemplateDefinition';
    import { load, save, deleteItems } from '@/utils/Http';
    import TableUtils from '@/mixins/TableUtils';
    import './styles/summaryTemplate.css';

    export default {
        name: 'SummaryTemplates',
        components: {
            Panel,
            CicCheckbox,
            EditTemplateDefinition,
        },
        mixins: [TableUtils],
        data() {
            return {
                templates: [],
                selected: [],
                item: null,
                queues: [],
                agentGroups: [],
                languages: [],
            };
        },
        created() {
            this.loadTable();
        },
        methods: {
            loadTable() {
                this.closePopup();
                this.selected = [];
                load('summarytemplates/get', {}, (response) => {
                    this.templates = response.templates;
                    this.queues = response.queues;
                    this.agentGroups = response.agentGroups;
                    this.languages = response.languages.map(lang => ({
                        value: lang.id,
                        label: lang.name,
                        code: lang.code,
                    }));
                });
            },
            openForm(templateId) {
                if (templateId) {
                    load('summarytemplate/get', { templateId }, (response) => {
                        this.item = response.template;
                    });
                } else {
                    const defaultLang = this.languages.find(lang => lang.code === this.$i18n.locale);
                    this.item = {
                        templateId: null,
                        templateName: '',
                        language: defaultLang ? defaultLang.value : (this.languages.length > 0 ? this.languages[0].value : ''),
                        summaryItems: [
                            {
                                goal: '',
                                style: 'bp',
                                anonymisation: false,
                                wordLimit: 200,
                            },
                        ],
                        customVocabularies: [],
                        queueIds: [],
                        agentGroupIds: [],
                        customPrompt: '',
                        templateType: 'SummarisationTemplate',
                    };
                }
            },
            handleTemplateSave() {
                if (this.item.templateName.trim() === '') {
                    alert(this.$t('Template Name is a required field'));
                    return;
                }

                if (!this.item.language && this.item.templateType === 'SummarisationTemplate') {
                    alert(this.$t('Language is a required field'));
                    return;
                }

                if (this.item.templateType === 'SummarisationTemplate') {
                    for (let item of this.item.summaryItems) {
                        if (!item.goal) {
                            alert(this.$t('Goal Description is a required field'));
                            return;
                        }
                    }

                    if (this.item.customVocabularies.length >= 1) {
                        for (let vocab of this.item.customVocabularies) {
                            if (!vocab.key || !vocab.value) {
                                alert(this.$t('Each custom vocabulary must have a word and definition'));
                                return;
                            }
                        }
                    }

                    save(
                        'summarytemplate/save',
                        {
                            ...this.item,
                            summaryItems: JSON.stringify(this.item.summaryItems),
                            customVocabularies: JSON.stringify(this.item.customVocabularies),
                            queueIds: JSON.stringify(this.item.queueIds),
                            agentGroupIds: JSON.stringify(this.item.agentGroupIds),
                        },
                        this.loadTable,
                    );
                } else if (this.item.templateType === 'PromptTemplate') {
                    if (this.item.customPrompt.trim() === '') {
                        alert(this.$t('Custom Prompt is a required field'));
                        return;
                    }

                    save(
                        'summaryprompt/save',
                        {
                            ...this.item,
                            queueIds: JSON.stringify(this.item.queueIds),
                            agentGroupIds: JSON.stringify(this.item.agentGroupIds),
                        },
                        this.loadTable,
                    );
                }
            },
            deleteSelectedTemplates() {
                deleteItems('summarytemplates/delete', { ids: JSON.stringify(this.selected) }, this.loadTable);
            },
        },
    };
</script>
